<!-- Add ngx-loading-bar at the top ot the display area -->
<ngx-loading-bar [includeSpinner]="false" color="rgb(29 112 183 / 40%)" height="4px" ref="http"></ngx-loading-bar>
<div class="layout-topbar red-nch ">
    <div class="topbar-start">
        <!-- <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button> -->
        <a class="cursor-pointer ml-4" (click)="onSidebarButtonHide()"><i class="pi pi-bars"
                style="font-size: 2rem; color: white;"></i></a>
        <div class="ml-4 flex">
            <a *ngIf="userAd; else loadingLogo" [routerLink]="['/app-layout/dash']" class="cursor-pointer">
                <img *ngIf="userAd" src="assets/demo/images/s.png" style="width: 50px;" />
            </a>
            <ng-template #loadingLogo>
                <p-skeleton shape="circle" size="4rem" styleClass="mr-2" borderRadius="50%"></p-skeleton>
            </ng-template>
        </div>
        <div class="ml-2 flex">
            <a *ngIf="userAd; else loadingLogoT" [routerLink]="['/app-layout/dash']" class="cursor-pointer">
                <p class="font-semibold text-900 m-0"
                    style="font-family: sans-serif !important; line-height: 100% !important; font-size: 33px !important;">
                    <span style="color: rgb(255, 255, 255) !important;">Deutsch</span>
                    <span style="color: rgb(255, 255, 255) !important;"> Institut</span>
                    <span style="color: rgb(255, 166, 0) !important;"></span>
                </p>
            </a>
            <ng-template #loadingLogoT>
                <p-skeleton width="14rem" height="4rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
    <div class="topbar-end">
        <ul class="topbar-menu" *ngIf="isLoggedIn">
            <li class="profile-item topbar-item" (click)="onSidebarButtonClick()">
                <div class="w-3rem mr-2 h-3rem border-circle shadow-1 flex align-items-center justify-content-center text-white font-bold text-lg"
                    [ngStyle]="{ 'background-color': getColorFromName(userAd?.name) }">
                    {{ getInitials(userAd?.name || "? ?") }}
                </div>
                <ng-template #loadingLogo>
                    <p-skeleton shape="circle" size="3rem" styleClass="mr-2" borderRadius="50%"></p-skeleton>
                </ng-template>
                <a class="cursor-pointer" *ngIf="userAd; else loadingLabel">
                    <p class="font-semibold text-900 m-0"
                        style="line-height: 0.7; font-size: 1.15rem !important; color: white !important;">
                        {{ userAd?.name }}
                    </p>
                    <span class="font-normal text-800 text-sm" style="color: white !important;">
                        {{ userAd?.jobTitle }} &nbsp;|&nbsp;<span class="font-normal">{{ userAd?.location }}</span>
                    </span>
                </a>
                <ng-template #loadingLabel>
                    <p-skeleton width="14rem" height="3rem"></p-skeleton>
                </ng-template>
            </li>
            <li #notification class="profile-item topbar-item mr-4"
                style="display: flow-root !important; color: white;">
                <a *ngIf="userAd else loadingNotif" pRipple class="cursor-pointer"
                    (click)="toggleSidebarNotification()">
                    <i class="pi pi-bell text-3xl grow" pBadge severity="danger" value="2"></i>
                </a>
                <ng-template #loadingNotif>
                    <p-skeleton size="3rem" styleClass="mr-2"></p-skeleton>
                </ng-template>
            </li>
            <li class="profile-item ml-1 mr-4" style="display: flow-root !important; color: white;">
                <a *ngIf="userAd; else loadingL" pRipple class="cursor-pointer" (click)="logout($event)"> <i
                        class="pi pi-sign-out text-3xl grow"></i></a>
                <p-confirmPopup key="confirm"></p-confirmPopup>
                <ng-template #loadingL>
                    <p-skeleton size="3rem" styleClass="mr-2"></p-skeleton>
                </ng-template>
            </li>
        </ul>
    </div>
</div>